import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DeliveryDetailQualityCheckContent from '../../components/DeliveryDetailQualityCheckContent/DeliveryDetailQualityCheckContent';
import DeliveryDetailTabContent from '../../components/DeliveryDetailTabContent/DeliveryDetailTabContent';
import SideNav from '../../components/shared/sidenav/SideNav';
import { IDeliveryDetail } from '../../models/DeliveryDetail';
import ApiService from '../../services/apiService';
import URL from '../../urls/Urls';
import './DeliveryDetail.scss';

const DeliveryDetail: React.FC = () => {
  const { id } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [deliveryDetails, setDeliveryDetails] = useState<IDeliveryDetail>();

  useEffect(() => {
    getDeliveryDetails(Number(id));
  }, [id]);

  const getDeliveryDetails = async (id: number) => {
    try {
      const { data } = await ApiService().client.get(
        URL.DELIVERY_DETAILS.GET_DELIVERY_DETAILS(id)
      );
      setDeliveryDetails(data.data);
    } catch (error) {
      console.error('Error fetching Delivery Details:', error);
    }
  };

  const handleHoldToggle = async (
    type: 'client_hold' | 'vendor_hold' | 'company_hold'
  ) => {
    try {
      if (deliveryDetails?.delivery_id) {
        let reason = '';
        if (!deliveryDetails[type]) {
          reason = prompt('Type Reason') || '';
        }
        const res = await ApiService().client.put(
          URL.DELIVERY_DETAILS.UPDATE_DELIVERY_DETAILS(Number(id)),
          {
            [type]: (!deliveryDetails[type]).toString(),
            hold_reason: reason,
          }
        );
        if (res.status === 200) {
          setDeliveryDetails((old) => {
            if (old) {
              return { ...old, [type]: !old[type] };
            }
            return old;
          });
        }
      }
    } catch (error) {
      console.error('Status change failed !');
    }
  };

  return (
    <div className="page-wrapper flex-row">
      <SideNav />

      <div className="delivery-details-page">
        <div className="delivery-details-page-header xetgo-font-tag px-16 py-12 flex-row gap-2">
          <span style={{ color: '#757575' }}> Purchase Request /</span>
          <span style={{ color: '#757575' }}>
            {deliveryDetails?.po_number} /
          </span>
          <span style={{ color: '#757575' }}> Vendor /</span>
          <a
            href={`/xetrack/delivery/${deliveryDetails?.delivery_id}/vendor/${deliveryDetails?.vendor.id}`}
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: 'none', color: '#757575' }}
            className="cursor-pointer"
          >
            {deliveryDetails?.vendor.name}
          </a>
          <span style={{ color: '#AA5200' }}> / {id} </span>
        </div>
        <div className="delivery-details-page-body p-16">
          <div className="flex-row align-items-center justify-content-space-between">
            <div className="delivery-page-tabs-container flex-row align-items-center gap-16">
              <div
                className={`delivery-page-tab px-12 py-8 xetgo-font-button-bold flex-row align-items-center gap-4 ${
                  activeTabIndex === 0 && 'active'
                }`}
                onClick={() => setActiveTabIndex(0)}
              >
                <img
                  src={
                    activeTabIndex === 0
                      ? 'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241004080554-truck-purple.svg'
                      : 'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241004080554-truck-brown.svg'
                  }
                />
                Delivery Details
              </div>

              <div
                className={`delivery-page-tab px-12 py-8 xetgo-font-button-bold flex-row align-items-center gap-4 ${
                  activeTabIndex === 1 && 'active'
                }`}
                onClick={() => setActiveTabIndex(1)}
              >
                <img
                  src={
                    activeTabIndex === 1
                      ? 'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241004080554-check-circle-purple.svg'
                      : 'https://d2k6zobmg5lufr.cloudfront.net/assets%2F20241004080554-check-circle-brown.svg'
                  }
                />
                Quality Check Details
              </div>
            </div>
            <div className="flex-row gap-16 align-items-center">
              <p className="xetgo-font-tag">Delivery on Hold</p>
              <div
                onClick={() => handleHoldToggle('client_hold')}
                className={`hold-toggle-main-container flex-row align-items-center gap-4 px-8 py-4 xetgo-font-tag bold cursor-pointer ${
                  deliveryDetails?.client_hold && 'hold-active '
                }`}
              >
                <p
                  className={`gradient-circle ${
                    deliveryDetails?.client_hold && 'gradient-circle-hold'
                  }`}
                ></p>
                <p>CLIENT</p>
              </div>
              <div
                onClick={() => handleHoldToggle('company_hold')}
                className={`hold-toggle-main-container flex-row align-items-center gap-4 px-8 py-4 xetgo-font-tag bold cursor-pointer ${
                  deliveryDetails?.company_hold && 'hold-active '
                }`}
              >
                <p
                  className={`gradient-circle ${
                    deliveryDetails?.company_hold && 'gradient-circle-hold'
                  }`}
                ></p>
                <p>XETGO</p>
              </div>
              <div
                onClick={() => handleHoldToggle('vendor_hold')}
                className={`hold-toggle-main-container flex-row align-items-center gap-4 px-8 py-4 xetgo-font-tag bold cursor-pointer ${
                  deliveryDetails?.vendor_hold && 'hold-active '
                }`}
              >
                <p
                  className={`gradient-circle ${
                    deliveryDetails?.vendor_hold && 'gradient-circle-hold'
                  }`}
                ></p>
                <p>VENDOR</p>
              </div>
            </div>
          </div>

          {activeTabIndex === 0 && deliveryDetails && (
            <DeliveryDetailTabContent
              purchased_product_delivery_schedule_id={Number(id)}
              deliveryDetails={deliveryDetails}
            />
          )}
          {activeTabIndex === 1 && (
            <DeliveryDetailQualityCheckContent
              purchased_product_delivery_schedule_id={Number(id)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryDetail;
